import { getSafeUrl } from "../../utils/helpers.js";
import Header from "components/Headers/Header";
import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { get } from "utils/api";
import plusSvg from "../../assets/images/plus.svg";
import furnishedSvg from "../../assets/images/furnished.svg";
import buildingSvg from "../../assets/images/Building.svg";
import waterGlassSvg from "../../assets/images/Water_Glass.svg";
import carSvg from "../../assets/images/car.svg";
import lockAccessSvg from "../../assets/images/lock_access.svg";
import directionToolSvg from "../../assets/images/direction_tool.svg";
import RulerSvg from "../../assets/images/ruler.svg";
import BathTubSvg from "../../assets/images/Bathtub.svg";
import BedImage from "../../assets/images/bed.svg";
import HouseDummyImg from "../../assets/images/houseDummy.webp";

const HouseList = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const addedBy = queryParams.get("userId");
  const houseId = queryParams.get("houseId");
  const [houseData, setHouseData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [sortColumn, setSortColumn] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc"); // 'asc' or 'desc'
  const allowedSortFields = ["name", "monthly_price"];

  const handleSort = (column) => {
    if (allowedSortFields.includes(column)) {
      if (sortColumn === column) {
        setSortOrder(sortOrder === "asc" ? "desc" : "asc");
      } else {
        setSortColumn(column);
        setSortOrder("asc");
      }
    }
  };
  const handleViewMore = (id) => {
    //  navigator(`/user/furniture_company/furniture`, {
    //    state: { furId: id },
    //  });
  };
   const handleError = (e) => {
    e.target.src = HouseDummyImg; // Fallback to the dummy image on error
  };

  const fetchApi = () => {
    setIsLoading(true);
    get(`api/admin/get/houseData`, { addedBy, houseId })
      .then((res) => {
        setHouseData(res.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchApi();
  }, [addedBy, houseId]);

  function isAnyDateBeforeToday(dates) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    for (const date of dates) {
      const inputDate = new Date(date);
      inputDate.setHours(0, 0, 0, 0);
      if (today <= inputDate) {
        return true;
      }
    }

    return false;
  }

  const sortedData = [...houseData].sort((a, b) => {
    const aValue = sortColumn ? a[sortColumn] : null;
    const bValue = sortColumn ? b[sortColumn] : null;

    // Ensure that aValue and bValue are arrays
    if (!Array.isArray(aValue) || !Array.isArray(bValue)) {
      return 0;
    }
    // Convert arrays to strings for lexicographical comparison
    const aValueString = aValue.join("");
    const bValueString = bValue.join("");
    return sortOrder === "asc"
      ? aValueString.localeCompare(bValueString)
      : bValueString.localeCompare(aValueString);
  });

  return (
    <>
      <Header title={"List of Houses"} />
      {/* <div className="container">
        {isLoading ? (
          <Spinner />
        ) : (
          sortedData.length > 0 && (
            <>
              <hr />
              <table className="table">
                <thead className="thead-light">
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col"></th>
                    <th scope="col" onClick={() => handleSort("name")}>
                      Name
                    </th>
                    <th scope="col" onClick={() => handleSort("monthly_price")}>
                      Price
                    </th>
                    <th scope="col">House Facility</th>
                    <th scope="col">Status</th>
                    <th scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  {sortedData.map((item, index) => (
                    <tr key={index}>
                      <th scope="row">{index + 1}</th>
                      <td>
                        <img src="../../assets/images/cpdelux.png" alt="" />
                      </td>
                      <td>{item.name}</td>
                      <td>${item.monthly_price}</td>
                      <td>{item.house_facility}</td>
                      <td
                        className={
                          isAnyDateBeforeToday(
                            item.booking_data.map(
                              (booking) => booking.lease_end_date
                            )
                          )
                            ? "booked"
                            : "not-booked"
                        }
                      >
                        {isAnyDateBeforeToday(
                          item.booking_data.map(
                            (booking) => booking.lease_end_date
                          )
                        )
                          ? "Booked"
                          : "Not Booked"}
                      </td>
                      <td>
                        <button onClick={() => handleViewMore(item.id)}>
                          View More
                        </button>
                      </td>{" "}
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )
        )}
      </div> */}

      <main>
        <style>
          {`
          .palm_step {
            flex-wrap: wrap;
          }
          .palm_step li {
            margin: 0 13px 13px 0;
          }
        `}
        </style>
        <div className="container-fluid px-4">
          <div className="row">
            <div className="col-md-12 col-12">
              <div className="main-box">
                <div className="content-header"></div>
                {houseData.length > 0 &&
                  houseData.map((value, i) => (
                    <div key={i + "_houses"} className="row">
                      <div className="col-12">
                        <div className="hist_main_2">
                          <div className="hist_img">
                            {value.houseImages.length > 0 && (
                              <img
                                style={{ width: "250px", height: "212px" }}
                                src={
                                  getSafeUrl(value?.houseImages.at(-1))?.imageUrl
                                }
                                alt="histhomeimg"
                                onError={handleError}
                              />
                            )}
                            <div className="brook_house">
                              {value.houseImages.length > 1 &&
                                value.houseImages.map(
                                  (imgValue, j) =>
                                    j > 0 && (
                                      <div key={j} className="house_img">
                                        <img
                                          style={{
                                            width: "75px",
                                            height: "70px",
                                          }}
                                          src={
                                            getSafeUrl(imgValue.imageUrl)
                                          }
                                          alt="hsofa"
                                        />
                                      </div>
                                    )
                                )}
                            </div>
                          </div>
                          <div className="hist_cont">
                            <div className="house_drop">
                              <h4>{value.name}</h4>
                              <div className="house_dinner">
                                <h2
                                  style={{
                                    color: "#ff5d1f",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {value?.booking_status}
                                </h2>
                                {/* <select
                                className="form-select"
                                aria-label="Default select example"
                              >
                                <option selected>Booked</option>
                                <option value="1">Not Booked</option>
                              </select> */}
                              </div>
                            </div>
                            <p>
                              {value?.full_address}
                              <br />
                              {value?.state}, {value?.zip_code},{" "}
                              {value?.country}
                            </p>
                            <h4>
                              $ {value.monthly_price}/
                              <span className="per_month">per month</span>
                            </h4>
                            <h4>Overview</h4>
                            <ul className="palm_step">
                              {value.house_facility && (
                                <li>
                                  <img src={furnishedSvg} alt="furnished" />
                                  <h4>{value.house_facility}</h4>
                                </li>
                              )}
                              {value?.floor && (
                                <li>
                                  <img src={buildingSvg} alt="furnished" />
                                  <h4>{value?.floor}</h4>
                                </li>
                              )}
                              {value.area && (
                                <li>
                                  <img src={RulerSvg} alt="furnished" />
                                  <h4>{value.area} SQ FT</h4>
                                </li>
                              )}
                              {value.bedroom_no && (
                                <li>
                                  <img src={BedImage} alt="furnished" />
                                  <h4>{value.bedroom_no} Bedrooms</h4>
                                </li>
                              )}
                              {value.bathroom_no && (
                                <li>
                                  <img src={BathTubSvg} alt="furnished" />
                                  <h4>{value.bathroom_no} Bathrooms</h4>
                                </li>
                              )}
                            </ul>
                            <ul className="palm_step palm_steps">
                              <li>
                                <img src={carSvg} alt="furnished" />
                                <h4>{value?.house_type}</h4>
                              </li>
                            </ul>
                            {/* <div className="dual-actions">
                    <div
                      className="house_det clickable"
                      onClick={() => {
                        editHouse(value);
                      }}
                    >
                 
                      Edit Details <i class="fa fa-solid fa-pen-to-square"></i>
                    
                    </div>
                    <div
                      className="house_rem clickable"
                      onClick={() => {
                        removeModal(value?.id);
                      }}
                    >
                      Remove <i class="fa fa-solid fa-trash"></i>
                    </div>
                  </div> */}
                          </div>
                        </div>
                        <hr className="m-0" />
                      </div>
                    </div>
                  ))}
                {isLoading && (
                  <div className="loading-data">
                    <Spinner></Spinner>
                  </div>
                )}

                {houseData.length == 0 && !isLoading && (
                  <div className="loading-data">
                    There is no house added by this house owner.
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default HouseList;
